import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "displayButton" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src"]

import { useActivityStore } from '@/stores/activity';
import { goToActivityPath } from '@/view/home/supportScript';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'floatButton',
  emits: ["openAgentPopup", "openRedEnvelop", "goToHome", "openPWA", 'handleShowTreasurePopup'],
  setup(__props, { emit: __emit }) {

const activityStore = useActivityStore()
const homeIconList = computed(() => activityStore.homeFloatActivityList)
const isDisplay = ref(true)
const router = useRouter()
const emits = __emit

const handleShowTreasurePopup = (path: any) => {
    emits('handleShowTreasurePopup', path)
    localStorage.setItem('redirectFromCalim', 'true')
}

const goToPath = (name: any) => {
    goToActivityPath(name, router,handleShowTreasurePopup, emits)
}

const handleShow = () => {
    isDisplay.value = !isDisplay.value
}

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "displayButtonWrapper",
      onClick: handleShow
    }, [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "spinner-ring" }, null, -1)),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_van_icon, {
          name: isDisplay.value ? 'cross' : 'plus'
        }, null, 8, ["name"])
      ])
    ]),
    _createVNode(_TransitionGroup, {
      name: "pop",
      tag: "div",
      class: "container"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(isDisplay.value ? homeIconList.value : [], (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item?.name,
            class: "icon-wrapper",
            style: _normalizeStyle({ transitionDelay: `${index * 0.05}s` }),
            onClick: ($event: any) => (goToPath(item?.name))
          }, [
            _createElementVNode("img", {
              src: item?.icon,
              alt: ""
            }, null, 8, _hoisted_3)
          ], 12, _hoisted_2))
        }), 128))
      ]),
      _: 1
    })
  ], 64))
}
}

})